module.exports = __webpack_public_path__ + "static/teen-health-5173456c7878abc757675907c50636c4.png";